<template>
  <div>
    <v-expand-x-transition>
      <landing-toolbar />
    </v-expand-x-transition>
    <Employee />
  </div>
</template>

<script>
import LandingToolbar from "../../components/LandingToolbar/LandingToolbar.vue";
import Employee from "../../components/GestionEmpleados/Views/Employee/Employee.vue";
export default {
  components: { LandingToolbar, Employee },
};
</script>
